import { Component, DestroyRef, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormArray, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { toast } from 'ngx-sonner';
import { v7 as uuidv7 } from 'uuid';

import { ButtonAddNewComponent } from '../../shared/components/button-add-new/button-add-new.component';
import { ExpansionPanel } from '../../shared/components/expansion-panel/expansion-panel.component';
import { SidepanelService } from '../../shared/components/sidepanel/sidepanel.service';
import { ToastrSuccessComponent } from '../../shared/components/toastr/toastr-success.component';
import { ModalitéCreateRequest } from '../requests/modalité-create-request.model';
import { ModalitéStore } from '../store/modalité.store';

@Component({
  selector: 'app-form-modalite',
  imports: [ButtonAddNewComponent, ReactiveFormsModule, ExpansionPanel, HlmInputImports],
  templateUrl: './form-modalités.component.html',
})
export class FormModalitésComponent implements OnInit {
  readonly #fb = inject(FormBuilder);
  readonly #sidepanelService = inject(SidepanelService);
  readonly #destroyRef = inject(DestroyRef);
  readonly #store = inject(ModalitéStore);

  readonly idCartographie = input.required<string>();

  readonly form = this.#fb.group({
    modalites: this.#fb.array([]),
  });

  ngOnInit(): void {
    this.addModalite();
    this.#sidepanelService.submit.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(() => this.onSubmit());
  }

  addModalite() {
    const modalité = this.#fb.group({
      nom: ['', [Validators.required]],
    });
    this.modalitesForm.push(modalité);
  }

  onSubmit() {
    const toastrId = uuidv7();

    const nouvellesModalités: ModalitéCreateRequest = {
      idCartographie: this.idCartographie(),
      modalites: this.modalitesForm.value
        .filter((x: { nom: string }) => !!x.nom?.trim())
        .map((x: { nom: string }) => ({
          nom: x.nom,
        })),
    };

    if (!nouvellesModalités.modalites || nouvellesModalités.modalites.length === 0) {
      this.#sidepanelService.close();
      return;
    }

    this.#store.ajouter({
      data: nouvellesModalités,
      next: () => {
        this.#store.charger(this.idCartographie());
        toast.custom(ToastrSuccessComponent, {
          componentProps: {
            message: 'Création des modalités réussie',
            id: toastrId,
          },
          id: toastrId,
        });
        this.#sidepanelService.close();
      },
    });
  }

  get modalitesForm() {
    return this.form.get('modalites') as FormArray;
  }
}
